import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface ContactPayload {
  name: string;
  phone: string;
  email: string;
  comment: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactApiService {
  private readonly baseUrl = environment.api.baseUrl;

  constructor(private readonly http: HttpClient) {}

  sendMessage(payload: ContactPayload): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/contact-us`, payload);
  }
}
